/**
 * Où revenir après la connexion.
 *
 * Le paramètre `retour` vient de l'adresse : n'importe qui peut l'écrire. On
 * n'accepte qu'un chemin interne, jamais `//autre-site.fr` ni `https://…`.
 */
export function cheminDeRetour(parametre: string | null): string | null {
  if (!parametre) return null;
  if (!parametre.startsWith('/') || parametre.startsWith('//') || parametre.startsWith('/\\')) {
    return null;
  }
  if (parametre.startsWith('/connexion')) return null;
  return parametre;
}
